import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useNavigate } from 'react-router-dom'
import { TIME_SELECTOR_ROUTE_PARAM } from './TimeSelector'
import { useQuery } from '../../../../hooks/useQuery'

export const CUSTOM_DATE_START_DATE_ROUTE_PARAM = 'startDate'
export const CUSTOM_DATE_END_DATE_ROUTE_PARAM = 'endDate'

export const TradeGraphCustomDatesForm = ({ minDate, maxDate }: { minDate: number; maxDate: number }) => {
    const query = useQuery()
    const navigate = useNavigate()
    const [endDate, setEndDate] = useState<Date | null>(
        new Date(query.get(CUSTOM_DATE_END_DATE_ROUTE_PARAM) || maxDate),
    )
    const [startDate, setStartDate] = useState<Date | null>(
        new Date(query.get(CUSTOM_DATE_START_DATE_ROUTE_PARAM) || minDate),
    )

    useEffect(() => {
        if (!query.get(CUSTOM_DATE_START_DATE_ROUTE_PARAM)) {
            query.set(CUSTOM_DATE_START_DATE_ROUTE_PARAM, new Date(minDate).toISOString().split('T')[0])
        }

        if (!query.get(CUSTOM_DATE_END_DATE_ROUTE_PARAM)) {
            query.set(CUSTOM_DATE_END_DATE_ROUTE_PARAM, new Date(maxDate).toISOString().split('T')[0])
        }

        query.set(TIME_SELECTOR_ROUTE_PARAM, 'custom')
        navigate(`?${query.toString()}`, { replace: true })
    }, [maxDate, minDate, navigate, query])

    const handleChangeEndDate = (d: Date | null) => {
        if (d === null) return

        setEndDate(d)
        query.set(CUSTOM_DATE_END_DATE_ROUTE_PARAM, d.toISOString().split('T')[0])
        query.set(TIME_SELECTOR_ROUTE_PARAM, 'custom')
        navigate(`?${query.toString()}`, { replace: true })
    }

    const handleChangeStartDate = (d: Date | null) => {
        if (d === null) return

        setStartDate(d)
        query.set(CUSTOM_DATE_START_DATE_ROUTE_PARAM, d.toISOString().split('T')[0])
        query.set(TIME_SELECTOR_ROUTE_PARAM, 'custom')
        navigate(`?${query.toString()}`, { replace: true })
    }

    return (
        <Box sx={{ padding: '20px 30px' }}>
            <DatePicker
                label='Startdatum'
                onChange={handleChangeStartDate}
                value={startDate}
                minDate={new Date(minDate)}
                sx={{ marginRight: 4 }}
            />
            <DatePicker label='Slutdatum' onChange={handleChangeEndDate} value={endDate} maxDate={new Date(maxDate)} />
        </Box>
    )
}
